import svg from 'src/images/custom-icons/analytics.icon.svg';

const analyticsSideBarTokens = {
    iconData: svg,
    iconWidth: 20,
    iconHeight: 20,
    iconTitle: 'Analytics'
};

export default analyticsSideBarTokens;
